import { useState } from "react";
import { cn } from "../../utils/cn";

export interface JsonViewerProps {
  value: unknown;
  collapsible?: boolean;
  collapsedByDefault?: boolean;
  className?: string;
  label?: string;
}

export function JsonViewer({
  value,
  collapsible = false,
  collapsedByDefault = false,
  className,
  label,
}: JsonViewerProps) {
  const [collapsed, setCollapsed] = useState(collapsedByDefault);
  const formatted = JSON.stringify(value, null, 2) ?? "null";
  const showCollapsedHint = collapsible && collapsed;

  return (
    <div className={cn("rounded-md border border-border bg-surface-muted", className)}>
      {(label || collapsible) && (
        <div className="flex items-center justify-between px-3 py-1.5 border-b border-border">
          {label && <span className="text-xs font-medium text-muted-foreground">{label}</span>}
          {collapsible && (
            <button
              type="button"
              className="text-xs text-primary hover:underline ml-auto"
              onClick={() => setCollapsed((c) => !c)}
            >
              {collapsed ? "expandir" : "recolher"}
            </button>
          )}
        </div>
      )}
      {!showCollapsedHint && (
        <pre className="text-xs p-3 overflow-auto max-h-96 font-mono leading-relaxed">
          {formatted}
        </pre>
      )}
      {showCollapsedHint && (
        <div className="text-xs text-muted-foreground italic px-3 py-2">
          (recolhido — clique em expandir)
        </div>
      )}
    </div>
  );
}
